export const translations = {
  es: {
    cta_strip: {
      default_text: '¿Listo para transformar tu estrategia?',
      bold_title: '¿Quieres saber cómo empezar?',
      bold_subtitle: 'Reserva una sesión estratégica sin compromiso con nuestro equipo.',
      cta: 'Agendar Sesión',
    },
    nav: {
      about: 'Nosotros',
      credits: 'Créditos de Plástico',
      process: 'Proceso',
      value: 'Oportunidad',
      benefits: 'Beneficios',
      team: 'Equipo',
      booking: 'Agendar Sesión',
    },
    hero: {
      badge: 'CSR & Finance Consulting',
      title_line1: 'No hablamos de',
      title_highlight: 'sostenibilidad.',
      title_line2: 'La hacemos tangible, medible y',
      title_accent: 'rentable.',
      subtitle: 'Planificación Patrimonial | Activos Emergentes | Créditos de Plástico',
      cta: 'Agendar Sesión Estratégica',
      cta_secondary: 'Descubre cómo funciona',
    },
    about: {
      caption: 'Sobre nosotros',
      title: 'Donde las finanzas encuentran el impacto real',
      description: 'CSR & Finance Consulting es la consultora liderada por Daniel Domínguez, asesor financiero visionario que une la rentabilidad patrimonial con la sostenibilidad verificable. Nuestro enfoque transforma residuos plásticos en activos financieros de alto potencial.',
      stat1_value: '500+',
      stat1_label: 'Clientes asesorados',
      stat2_value: '€2M+',
      stat2_label: 'En créditos gestionados',
      stat3_value: '100%',
      stat3_label: 'Impacto verificable',
      quote: '"La verdadera sostenibilidad no es un coste. Es la inversión más inteligente de esta década."',
      quote_author: 'Daniel Domínguez — Fundador & CEO, CSR & Finance Consulting',
    },
    credits: {
      caption: 'Créditos de Plástico',
      title: 'El plástico es el nuevo activo financiero',
      description: 'Los Créditos de Plástico certifican la retirada y transformación de residuos plásticos del medio ambiente. Cada crédito equivale a 1 tonelada de plástico reciclado, convertido en Bio-oil mediante pirólisis avanzada.',
      card1_title: 'Certificación ISCC',
      card1_desc: 'Cada crédito cuenta con certificación internacional que garantiza la trazabilidad completa del proceso.',
      card2_title: 'Respaldado por Shell',
      card2_desc: 'El Bio-oil resultante es adquirido por Shell, asegurando la demanda y liquidez del activo.',
      card3_title: 'Impacto Medible',
      card3_desc: 'Cada crédito elimina 1 tonelada de plástico del medio ambiente con verificación independiente.',
      card4_title: 'Activo con Potencial',
      card4_desc: 'Similar a los créditos de carbono, el mercado de créditos de plástico está en fase temprana con alto potencial de revalorización.',
    },
    process: {
      caption: 'El Proceso Corsair',
      title: 'De residuo a activo: Tecnología Waste-to-Oil',
      step1_title: 'Recolección',
      step1_desc: 'Los residuos plásticos son recolectados y clasificados en plantas certificadas.',
      step2_title: 'Pirólisis',
      step2_desc: 'El plástico se transforma en Bio-oil mediante pirólisis avanzada en las instalaciones de Corsair Group.',
      step3_title: 'Certificación',
      step3_desc: 'Cada lote recibe certificación ISCC, garantizando trazabilidad y calidad del Bio-oil.',
      step4_title: 'Comercialización',
      step4_desc: 'Shell adquiere el Bio-oil certificado, cerrando el ciclo de la economía circular.',
      partner: 'Tecnología respaldada por',
      official_rep: 'Representante Oficial en España',
      partner_desc: 'CSR & Finance Consulting es representante autorizado de Corsair Group en España. Tecnología Waste-to-Oil respaldada por Shell con certificación ISCC.',
    },
    value: {
      caption: 'Oportunidad de Inversión',
      title: 'Entrada anticipada al mercado',
      entry_label: 'Precio de entrada actual',
      entry_value: '0,015€',
      entry_unit: 'por crédito',
      market_label: 'Valor de mercado estimado',
      market_value: '0,07€',
      market_unit: 'por crédito',
      potential: 'Potencial de revalorización',
      potential_value: '×4.6',
      disclaimer: 'Los valores mostrados representan potencial de revalorización basado en proyecciones de mercado. No constituyen una garantía de rentabilidad.',
      portfolio_title: 'Estrategia de cartera recomendada',
      portfolio_desc: 'Los Créditos de Plástico deben representar entre el 10% y 20% de una cartera diversificada, combinados con activos tradicionales para un perfil equilibrado.',
    },
    benefits: {
      caption: 'Beneficios',
      title: 'Soluciones para cada perfil',
      ceo_title: 'Para CEOs y Fundadores',
      ceo_benefit1: 'Mejora las métricas ESG de tu empresa con impacto real y verificable',
      ceo_benefit2: 'Evita el greenwashing: cada crédito está certificado y trazable',
      ceo_benefit3: 'El 78% de los consumidores buscan marcas sostenibles',
      ceo_benefit4: 'Posiciona tu marca como líder en economía circular',
      ceo_benefit5: 'Cumple anticipadamente con normativas europeas de sostenibilidad',
      investor_title: 'Para Inversores',
      investor_benefit1: 'Accede a un mercado emergente con alto potencial de revalorización',
      investor_benefit2: 'Diversifica tu cartera con un activo respaldado por demanda real',
      investor_benefit3: 'Entrada a precio preferencial antes de la expansión del mercado',
      investor_benefit4: 'Liquidez garantizada: Shell compra el 100% del Bio-oil producido',
      investor_benefit5: 'Impacto ambiental positivo: inversión con propósito verificable',
    },
    team: {
      caption: 'Nuestro Equipo',
      title: 'Liderado por expertos en finanzas e impacto',
      daniel_name: 'Daniel Domínguez',
      daniel_role: 'Fundador & CEO',
      daniel_bio: 'Asesor financiero con más de 15 años de experiencia en planificación patrimonial y activos emergentes. Pionero en la integración de créditos de plástico como instrumento de inversión sostenible en el mercado español. Representante autorizado de Corsair Group en España.',
      daniel_specialties: 'Planificación Patrimonial, Activos ESG, Créditos de Plástico, Economía Circular',
      linkedin: 'Conectar en LinkedIn',
      cta: 'Agenda una sesión con nuestro equipo',
    },
    booking: {
      caption: 'Sesión Estratégica',
      title: 'Agenda tu consulta personalizada',
      description: 'En una sesión de 30 minutos, uno de nuestros asesores analizará tu perfil y te mostrará cómo los Créditos de Plástico pueden transformar tu estrategia patrimonial o corporativa.',
      cta: 'Reservar Sesión',
      feature1: 'Sin compromiso',
      feature2: 'Análisis personalizado',
      feature3: '30 min con un asesor',
    },
    footer: {
      brand: 'CSR & Finance Consulting',
      tagline: 'La sostenibilidad como activo financiero.',
      services: 'Servicios',
      service1: 'Planificación Patrimonial',
      service2: 'Activos Emergentes',
      service3: 'Créditos de Plástico',
      service4: 'Consultoría ESG',
      legal: 'Legal',
      privacy: 'Política de Privacidad',
      terms: 'Términos y Condiciones',
      cookies: 'Política de Cookies',
      contact: 'Contacto',
      email: 'info@csrspain.com',
      location: 'Madrid, España',
      rights: '© 2025 CSR & Finance Consulting. Todos los derechos reservados.',
      disclaimer: 'Este sitio web es informativo. No constituye asesoramiento financiero. Consulte con un profesional antes de tomar decisiones de inversión.',
    },
    contact: {
      title: 'Contáctanos',
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      message: 'Mensaje',
      send: 'Enviar Mensaje',
      success: 'Mensaje enviado correctamente. Nos pondremos en contacto pronto.',
      error: 'Error al enviar el mensaje. Inténtelo de nuevo.',
    },
  },

  en: {
    cta_strip: {
      default_text: 'Ready to transform your strategy?',
      bold_title: 'Want to know how to get started?',
      bold_subtitle: 'Book a no-commitment strategic session with our team.',
      cta: 'Book a Session',
    },
    nav: {
      about: 'About',
      credits: 'Plastic Credits',
      process: 'Process',
      value: 'Opportunity',
      benefits: 'Benefits',
      team: 'Team',
      booking: 'Book a Session',
    },
    hero: {
      badge: 'CSR & Finance Consulting',
      title_line1: "We don't talk about",
      title_highlight: 'sustainability.',
      title_line2: 'We make it tangible, measurable and',
      title_accent: 'profitable.',
      subtitle: 'Wealth Planning | Emerging Assets | Plastic Credits',
      cta: 'Book a Strategic Session',
      cta_secondary: 'Discover how it works',
    },
    about: {
      caption: 'About us',
      title: 'Where finance meets real impact',
      description: 'CSR & Finance Consulting is the consultancy led by Daniel Domínguez, a visionary financial advisor who combines wealth profitability with verifiable sustainability. Our approach transforms plastic waste into high-potential financial assets.',
      stat1_value: '500+',
      stat1_label: 'Clients advised',
      stat2_value: '€2M+',
      stat2_label: 'In managed credits',
      stat3_value: '100%',
      stat3_label: 'Verifiable impact',
      quote: '"True sustainability is not a cost. It is the smartest investment of this decade."',
      quote_author: 'Daniel Domínguez — Founder & CEO, CSR & Finance Consulting',
    },
    credits: {
      caption: 'Plastic Credits',
      title: 'Plastic is the new financial asset',
      description: 'Plastic Credits certify the removal and transformation of plastic waste from the environment. Each credit equals 1 ton of recycled plastic, converted into Bio-oil through advanced pyrolysis.',
      card1_title: 'ISCC Certification',
      card1_desc: 'Each credit has international certification ensuring complete traceability of the process.',
      card2_title: 'Backed by Shell',
      card2_desc: 'The resulting Bio-oil is purchased by Shell, ensuring demand and asset liquidity.',
      card3_title: 'Measurable Impact',
      card3_desc: 'Each credit removes 1 ton of plastic from the environment with independent verification.',
      card4_title: 'High Potential Asset',
      card4_desc: 'Similar to carbon credits, the plastic credit market is in its early stage with high revaluation potential.',
    },
    process: {
      caption: 'The Corsair Process',
      title: 'From waste to asset: Waste-to-Oil Technology',
      step1_title: 'Collection',
      step1_desc: 'Plastic waste is collected and sorted at certified facilities.',
      step2_title: 'Pyrolysis',
      step2_desc: 'Plastic is transformed into Bio-oil through advanced pyrolysis at Corsair Group facilities.',
      step3_title: 'Certification',
      step3_desc: 'Each batch receives ISCC certification, guaranteeing traceability and Bio-oil quality.',
      step4_title: 'Commercialization',
      step4_desc: 'Shell acquires the certified Bio-oil, closing the circular economy cycle.',
      partner: 'Technology backed by',
      official_rep: 'Official Representative in Spain',
      partner_desc: 'CSR & Finance Consulting is an authorized representative of Corsair Group in Spain. Waste-to-Oil technology backed by Shell with ISCC certification.',
    },
    value: {
      caption: 'Investment Opportunity',
      title: 'Early market entry',
      entry_label: 'Current entry price',
      entry_value: '€0.015',
      entry_unit: 'per credit',
      market_label: 'Estimated market value',
      market_value: '€0.07',
      market_unit: 'per credit',
      potential: 'Revaluation potential',
      potential_value: '×4.6',
      disclaimer: 'The values shown represent revaluation potential based on market projections. They do not constitute a guarantee of profitability.',
      portfolio_title: 'Recommended portfolio strategy',
      portfolio_desc: 'Plastic Credits should represent 10% to 20% of a diversified portfolio, combined with traditional assets for a balanced profile.',
    },
    benefits: {
      caption: 'Benefits',
      title: 'Solutions for every profile',
      ceo_title: 'For CEOs & Founders',
      ceo_benefit1: 'Improve your ESG metrics with real, verifiable impact',
      ceo_benefit2: 'Avoid greenwashing: every credit is certified and traceable',
      ceo_benefit3: '78% of consumers seek sustainable brands',
      ceo_benefit4: 'Position your brand as a circular economy leader',
      ceo_benefit5: 'Comply early with European sustainability regulations',
      investor_title: 'For Investors',
      investor_benefit1: 'Access an emerging market with high revaluation potential',
      investor_benefit2: 'Diversify your portfolio with an asset backed by real demand',
      investor_benefit3: 'Preferential entry price before market expansion',
      investor_benefit4: 'Guaranteed liquidity: Shell purchases 100% of Bio-oil produced',
      investor_benefit5: 'Positive environmental impact: investment with verifiable purpose',
    },
    team: {
      caption: 'Our Team',
      title: 'Led by experts in finance and impact',
      daniel_name: 'Daniel Domínguez',
      daniel_role: 'Founder & CEO',
      daniel_bio: 'Financial advisor with over 15 years of experience in wealth planning and emerging assets. Pioneer in integrating plastic credits as a sustainable investment instrument in the Spanish market. Authorized representative of Corsair Group in Spain.',
      daniel_specialties: 'Wealth Planning, ESG Assets, Plastic Credits, Circular Economy',
      linkedin: 'Connect on LinkedIn',
      cta: 'Book a session with our team',
    },
    booking: {
      caption: 'Strategic Session',
      title: 'Book your personalized consultation',
      description: 'In a 30-minute session, one of our advisors will analyze your profile and show you how Plastic Credits can transform your wealth or corporate strategy.',
      cta: 'Book a Session',
      feature1: 'No commitment',
      feature2: 'Personalized analysis',
      feature3: '30 min with an advisor',
    },
    footer: {
      brand: 'CSR & Finance Consulting',
      tagline: 'Sustainability as a financial asset.',
      services: 'Services',
      service1: 'Wealth Planning',
      service2: 'Emerging Assets',
      service3: 'Plastic Credits',
      service4: 'ESG Consulting',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
      cookies: 'Cookie Policy',
      contact: 'Contact',
      email: 'info@csrspain.com',
      location: 'Madrid, Spain',
      rights: '© 2025 CSR & Finance Consulting. All rights reserved.',
      disclaimer: 'This website is informational. It does not constitute financial advice. Consult a professional before making investment decisions.',
    },
    contact: {
      title: 'Contact Us',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      send: 'Send Message',
      success: 'Message sent successfully. We will get in touch soon.',
      error: 'Error sending message. Please try again.',
    },
  },

  fr: {
    cta_strip: {
      default_text: 'Prêt à transformer votre stratégie ?',
      bold_title: 'Vous voulez savoir comment commencer ?',
      bold_subtitle: 'Réservez une session stratégique sans engagement avec notre équipe.',
      cta: 'Réserver une Session',
    },
    nav: {
      about: 'À Propos',
      credits: 'Crédits Plastique',
      process: 'Processus',
      value: 'Opportunité',
      benefits: 'Avantages',
      team: 'Équipe',
      booking: 'Réserver une Session',
    },
    hero: {
      badge: 'CSR & Finance Consulting',
      title_line1: 'Nous ne parlons pas de',
      title_highlight: 'durabilité.',
      title_line2: 'Nous la rendons tangible, mesurable et',
      title_accent: 'rentable.',
      subtitle: 'Planification Patrimoniale | Actifs Émergents | Crédits Plastique',
      cta: 'Réserver une Session Stratégique',
      cta_secondary: 'Découvrez comment ça fonctionne',
    },
    about: {
      caption: 'À Propos',
      title: 'Là où la finance rencontre l\'impact réel',
      description: 'CSR & Finance Consulting est le cabinet de conseil dirigé par Daniel Domínguez, un conseiller financier visionnaire qui allie rentabilité patrimoniale et durabilité vérifiable. Notre approche transforme les déchets plastiques en actifs financiers à haut potentiel.',
      stat1_value: '500+',
      stat1_label: 'Clients conseillés',
      stat2_value: '2M€+',
      stat2_label: 'En crédits gérés',
      stat3_value: '100%',
      stat3_label: 'Impact vérifiable',
      quote: '"La vraie durabilité n\'est pas un coût. C\'est l\'investissement le plus intelligent de cette décennie."',
      quote_author: 'Daniel Domínguez — Fondateur & PDG, CSR & Finance Consulting',
    },
    credits: {
      caption: 'Crédits Plastique',
      title: 'Le plastique est le nouvel actif financier',
      description: 'Les Crédits Plastique certifient le retrait et la transformation des déchets plastiques de l\'environnement. Chaque crédit équivaut à 1 tonne de plastique recyclé, converti en Bio-huile par pyrolyse avancée.',
      card1_title: 'Certification ISCC',
      card1_desc: 'Chaque crédit bénéficie d\'une certification internationale garantissant la traçabilité complète du processus.',
      card2_title: 'Soutenu par Shell',
      card2_desc: 'Le Bio-huile résultant est acheté par Shell, assurant la demande et la liquidité de l\'actif.',
      card3_title: 'Impact Mesurable',
      card3_desc: 'Chaque crédit élimine 1 tonne de plastique de l\'environnement avec vérification indépendante.',
      card4_title: 'Actif à Haut Potentiel',
      card4_desc: 'Similaire aux crédits carbone, le marché des crédits plastique est en phase précoce avec un fort potentiel de revalorisation.',
    },
    process: {
      caption: 'Le Processus Corsair',
      title: 'Du déchet à l\'actif : Technologie Waste-to-Oil',
      step1_title: 'Collecte',
      step1_desc: 'Les déchets plastiques sont collectés et triés dans des installations certifiées.',
      step2_title: 'Pyrolyse',
      step2_desc: 'Le plastique est transformé en Bio-huile par pyrolyse avancée dans les installations de Corsair Group.',
      step3_title: 'Certification',
      step3_desc: 'Chaque lot reçoit la certification ISCC, garantissant traçabilité et qualité du Bio-huile.',
      step4_title: 'Commercialisation',
      step4_desc: 'Shell acquiert le Bio-huile certifié, fermant le cycle de l\'économie circulaire.',
      partner: 'Technologie soutenue par',
      official_rep: 'Représentant Officiel en Espagne',
      partner_desc: 'CSR & Finance Consulting est représentant autorisé de Corsair Group en Espagne. Technologie Waste-to-Oil soutenue par Shell avec certification ISCC.',
    },
    value: {
      caption: 'Opportunité d\'Investissement',
      title: 'Entrée anticipée sur le marché',
      entry_label: 'Prix d\'entrée actuel',
      entry_value: '0,015€',
      entry_unit: 'par crédit',
      market_label: 'Valeur de marché estimée',
      market_value: '0,07€',
      market_unit: 'par crédit',
      potential: 'Potentiel de revalorisation',
      potential_value: '×4.6',
      disclaimer: 'Les valeurs affichées représentent un potentiel de revalorisation basé sur des projections de marché. Elles ne constituent pas une garantie de rentabilité.',
      portfolio_title: 'Stratégie de portefeuille recommandée',
      portfolio_desc: 'Les Crédits Plastique doivent représenter 10% à 20% d\'un portefeuille diversifié, combinés avec des actifs traditionnels pour un profil équilibré.',
    },
    benefits: {
      caption: 'Avantages',
      title: 'Solutions pour chaque profil',
      ceo_title: 'Pour les PDG et Fondateurs',
      ceo_benefit1: 'Améliorez vos métriques ESG avec un impact réel et vérifiable',
      ceo_benefit2: 'Évitez le greenwashing : chaque crédit est certifié et traçable',
      ceo_benefit3: '78% des consommateurs recherchent des marques durables',
      ceo_benefit4: 'Positionnez votre marque comme leader de l\'économie circulaire',
      ceo_benefit5: 'Conformez-vous par anticipation aux réglementations européennes',
      investor_title: 'Pour les Investisseurs',
      investor_benefit1: 'Accédez à un marché émergent à fort potentiel de revalorisation',
      investor_benefit2: 'Diversifiez votre portefeuille avec un actif soutenu par une demande réelle',
      investor_benefit3: 'Prix d\'entrée préférentiel avant l\'expansion du marché',
      investor_benefit4: 'Liquidité garantie : Shell achète 100% du Bio-huile produit',
      investor_benefit5: 'Impact environnemental positif : investissement avec un objectif vérifiable',
    },
    team: {
      caption: 'Notre Équipe',
      title: 'Dirigée par des experts en finance et impact',
      daniel_name: 'Daniel Domínguez',
      daniel_role: 'Fondateur & PDG',
      daniel_bio: 'Conseiller financier avec plus de 15 ans d\'expérience en planification patrimoniale et actifs émergents. Pionnier dans l\'intégration des crédits plastique comme instrument d\'investissement durable sur le marché espagnol. Représentant autorisé de Corsair Group en Espagne.',
      daniel_specialties: 'Planification Patrimoniale, Actifs ESG, Crédits Plastique, Économie Circulaire',
      linkedin: 'Se connecter sur LinkedIn',
      cta: 'Réservez une session avec notre équipe',
    },
    booking: {
      caption: 'Session Stratégique',
      title: 'Réservez votre consultation personnalisée',
      description: 'En 30 minutes, l\'un de nos conseillers analysera votre profil et vous montrera comment les Crédits Plastique peuvent transformer votre stratégie patrimoniale ou d\'entreprise.',
      cta: 'Réserver une Session',
      feature1: 'Sans engagement',
      feature2: 'Analyse personnalisée',
      feature3: '30 min avec un conseiller',
    },
    footer: {
      brand: 'CSR & Finance Consulting',
      tagline: 'La durabilité comme actif financier.',
      services: 'Services',
      service1: 'Planification Patrimoniale',
      service2: 'Actifs Émergents',
      service3: 'Crédits Plastique',
      service4: 'Conseil ESG',
      legal: 'Mentions Légales',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions Générales',
      cookies: 'Politique de Cookies',
      contact: 'Contact',
      email: 'info@csrspain.com',
      location: 'Madrid, Espagne',
      rights: '© 2025 CSR & Finance Consulting. Tous droits réservés.',
      disclaimer: 'Ce site est informatif. Il ne constitue pas un conseil financier. Consultez un professionnel avant de prendre des décisions d\'investissement.',
    },
    contact: {
      title: 'Contactez-nous',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      message: 'Message',
      send: 'Envoyer le Message',
      success: 'Message envoyé avec succès. Nous vous contacterons bientôt.',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.',
    },
  },

  de: {
    cta_strip: {
      default_text: 'Bereit, Ihre Strategie zu transformieren?',
      bold_title: 'Möchten Sie wissen, wie Sie anfangen können?',
      bold_subtitle: 'Buchen Sie ein unverbindliches Strategiegespräch mit unserem Team.',
      cta: 'Termin buchen',
    },
    nav: {
      about: 'Über uns',
      credits: 'Plastik-Credits',
      process: 'Prozess',
      value: 'Chance',
      benefits: 'Vorteile',
      team: 'Team',
      booking: 'Termin buchen',
    },
    hero: {
      badge: 'CSR & Finance Consulting',
      title_line1: 'Wir reden nicht über',
      title_highlight: 'Nachhaltigkeit.',
      title_line2: 'Wir machen sie greifbar, messbar und',
      title_accent: 'profitabel.',
      subtitle: 'Vermögensplanung | Neue Anlageklassen | Plastik-Credits',
      cta: 'Strategiegespräch buchen',
      cta_secondary: 'Erfahren Sie wie es funktioniert',
    },
    about: {
      caption: 'Über uns',
      title: 'Wo Finanzen auf echten Impact treffen',
      description: 'CSR & Finance Consulting ist die Beratung unter der Leitung von Daniel Domínguez, einem visionären Finanzberater, der Vermögensrentabilität mit überprüfbarer Nachhaltigkeit verbindet. Unser Ansatz verwandelt Plastikmüll in Finanzanlagen mit hohem Potenzial.',
      stat1_value: '500+',
      stat1_label: 'Beratene Kunden',
      stat2_value: '2Mio.€+',
      stat2_label: 'Verwaltete Credits',
      stat3_value: '100%',
      stat3_label: 'Überprüfbarer Impact',
      quote: '"Echte Nachhaltigkeit ist keine Kosten. Sie ist die klügste Investition dieses Jahrzehnts."',
      quote_author: 'Daniel Domínguez — Gründer & CEO, CSR & Finance Consulting',
    },
    credits: {
      caption: 'Plastik-Credits',
      title: 'Plastik ist die neue Anlageklasse',
      description: 'Plastik-Credits zertifizieren die Entnahme und Umwandlung von Plastikmüll aus der Umwelt. Jeder Credit entspricht 1 Tonne recyceltem Plastik, umgewandelt in Bio-Öl durch fortschrittliche Pyrolyse.',
      card1_title: 'ISCC-Zertifizierung',
      card1_desc: 'Jeder Credit verfügt über eine internationale Zertifizierung, die die vollständige Rückverfolgbarkeit des Prozesses gewährleistet.',
      card2_title: 'Von Shell unterstützt',
      card2_desc: 'Das resultierende Bio-Öl wird von Shell gekauft, was Nachfrage und Liquidität des Assets sichert.',
      card3_title: 'Messbarer Impact',
      card3_desc: 'Jeder Credit entfernt 1 Tonne Plastik aus der Umwelt mit unabhängiger Überprüfung.',
      card4_title: 'Hohes Potenzial',
      card4_desc: 'Ähnlich wie CO2-Zertifikate befindet sich der Plastik-Credit-Markt in einer frühen Phase mit hohem Wertsteigerungspotenzial.',
    },
    process: {
      caption: 'Der Corsair-Prozess',
      title: 'Vom Abfall zum Asset: Waste-to-Oil Technologie',
      step1_title: 'Sammlung',
      step1_desc: 'Plastikmüll wird in zertifizierten Anlagen gesammelt und sortiert.',
      step2_title: 'Pyrolyse',
      step2_desc: 'Plastik wird in den Anlagen der Corsair Group durch fortschrittliche Pyrolyse in Bio-Öl umgewandelt.',
      step3_title: 'Zertifizierung',
      step3_desc: 'Jede Charge erhält die ISCC-Zertifizierung, die Rückverfolgbarkeit und Bio-Öl-Qualität garantiert.',
      step4_title: 'Vermarktung',
      step4_desc: 'Shell erwirbt das zertifizierte Bio-Öl und schließt den Kreislauf der Kreislaufwirtschaft.',
      partner: 'Technologie unterstützt von',
      official_rep: 'Offizieller Vertreter in Spanien',
      partner_desc: 'CSR & Finance Consulting ist autorisierter Vertreter der Corsair Group in Spanien. Waste-to-Oil-Technologie unterstützt von Shell mit ISCC-Zertifizierung.',
    },
    value: {
      caption: 'Investitionsmöglichkeit',
      title: 'Frühzeitiger Markteinstieg',
      entry_label: 'Aktueller Einstiegspreis',
      entry_value: '0,015€',
      entry_unit: 'pro Credit',
      market_label: 'Geschätzter Marktwert',
      market_value: '0,07€',
      market_unit: 'pro Credit',
      potential: 'Wertsteigerungspotenzial',
      potential_value: '×4.6',
      disclaimer: 'Die angezeigten Werte stellen Wertsteigerungspotenzial basierend auf Marktprognosen dar. Sie stellen keine Renditegarantie dar.',
      portfolio_title: 'Empfohlene Portfolio-Strategie',
      portfolio_desc: 'Plastik-Credits sollten 10% bis 20% eines diversifizierten Portfolios ausmachen, kombiniert mit traditionellen Anlagen für ein ausgewogenes Profil.',
    },
    benefits: {
      caption: 'Vorteile',
      title: 'Lösungen für jedes Profil',
      ceo_title: 'Für CEOs & Gründer',
      ceo_benefit1: 'Verbessern Sie Ihre ESG-Kennzahlen mit echtem, überprüfbarem Impact',
      ceo_benefit2: 'Vermeiden Sie Greenwashing: Jeder Credit ist zertifiziert und rückverfolgbar',
      ceo_benefit3: '78% der Verbraucher suchen nachhaltige Marken',
      ceo_benefit4: 'Positionieren Sie Ihre Marke als Vorreiter der Kreislaufwirtschaft',
      ceo_benefit5: 'Erfüllen Sie frühzeitig europäische Nachhaltigkeitsvorschriften',
      investor_title: 'Für Investoren',
      investor_benefit1: 'Zugang zu einem aufstrebenden Markt mit hohem Wertsteigerungspotenzial',
      investor_benefit2: 'Diversifizieren Sie Ihr Portfolio mit einem durch reale Nachfrage gestützten Asset',
      investor_benefit3: 'Vorzugspreis vor Marktexpansion',
      investor_benefit4: 'Garantierte Liquidität: Shell kauft 100% des produzierten Bio-Öls',
      investor_benefit5: 'Positiver Umwelteinfluss: Investition mit überprüfbarem Zweck',
    },
    team: {
      caption: 'Unser Team',
      title: 'Geführt von Experten für Finanzen und Impact',
      daniel_name: 'Daniel Domínguez',
      daniel_role: 'Gründer & CEO',
      daniel_bio: 'Finanzberater mit über 15 Jahren Erfahrung in Vermögensplanung und aufstrebenden Anlageklassen. Pionier bei der Integration von Plastik-Credits als nachhaltiges Anlageinstrument auf dem spanischen Markt. Autorisierter Vertreter der Corsair Group in Spanien.',
      daniel_specialties: 'Vermögensplanung, ESG-Anlagen, Plastik-Credits, Kreislaufwirtschaft',
      linkedin: 'Auf LinkedIn verbinden',
      cta: 'Buchen Sie eine Sitzung mit unserem Team',
    },
    booking: {
      caption: 'Strategiegespräch',
      title: 'Buchen Sie Ihr persönliches Beratungsgespräch',
      description: 'In 30 Minuten analysiert einer unserer Berater Ihr Profil und zeigt Ihnen, wie Plastik-Credits Ihre Vermögens- oder Unternehmensstrategie transformieren können.',
      cta: 'Termin buchen',
      feature1: 'Unverbindlich',
      feature2: 'Personalisierte Analyse',
      feature3: '30 Min. mit einem Berater',
    },
    footer: {
      brand: 'CSR & Finance Consulting',
      tagline: 'Nachhaltigkeit als Finanzanlage.',
      services: 'Dienstleistungen',
      service1: 'Vermögensplanung',
      service2: 'Neue Anlageklassen',
      service3: 'Plastik-Credits',
      service4: 'ESG-Beratung',
      legal: 'Rechtliches',
      privacy: 'Datenschutzrichtlinie',
      terms: 'AGB',
      cookies: 'Cookie-Richtlinie',
      contact: 'Kontakt',
      email: 'info@csrspain.com',
      location: 'Madrid, Spanien',
      rights: '© 2025 CSR & Finance Consulting. Alle Rechte vorbehalten.',
      disclaimer: 'Diese Website dient Informationszwecken. Sie stellt keine Finanzberatung dar. Konsultieren Sie einen Fachmann, bevor Sie Anlageentscheidungen treffen.',
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      message: 'Nachricht',
      send: 'Nachricht senden',
      success: 'Nachricht erfolgreich gesendet. Wir melden uns bald.',
      error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    },
  },

  pt: {
    cta_strip: {
      default_text: 'Pronto para transformar a sua estratégia?',
      bold_title: 'Quer saber como começar?',
      bold_subtitle: 'Reserve uma sessão estratégica sem compromisso com a nossa equipa.',
      cta: 'Agendar Sessão',
    },
    nav: {
      about: 'Sobre',
      credits: 'Créditos de Plástico',
      process: 'Processo',
      value: 'Oportunidade',
      benefits: 'Benefícios',
      team: 'Equipa',
      booking: 'Agendar Sessão',
    },
    hero: {
      badge: 'CSR & Finance Consulting',
      title_line1: 'Não falamos de',
      title_highlight: 'sustentabilidade.',
      title_line2: 'Tornamos-la tangível, mensurável e',
      title_accent: 'rentável.',
      subtitle: 'Planeamento Patrimonial | Ativos Emergentes | Créditos de Plástico',
      cta: 'Agendar Sessão Estratégica',
      cta_secondary: 'Descubra como funciona',
    },
    about: {
      caption: 'Sobre nós',
      title: 'Onde as finanças encontram o impacto real',
      description: 'CSR & Finance Consulting é a consultora liderada por Daniel Domínguez, consultor financeiro visionário que une a rentabilidade patrimonial com a sustentabilidade verificável. A nossa abordagem transforma resíduos plásticos em ativos financeiros de alto potencial.',
      stat1_value: '500+',
      stat1_label: 'Clientes assessorados',
      stat2_value: '2M€+',
      stat2_label: 'Em créditos geridos',
      stat3_value: '100%',
      stat3_label: 'Impacto verificável',
      quote: '"A verdadeira sustentabilidade não é um custo. É o investimento mais inteligente desta década."',
      quote_author: 'Daniel Domínguez — Fundador & CEO, CSR & Finance Consulting',
    },
    credits: {
      caption: 'Créditos de Plástico',
      title: 'O plástico é o novo ativo financeiro',
      description: 'Os Créditos de Plástico certificam a retirada e transformação de resíduos plásticos do ambiente. Cada crédito equivale a 1 tonelada de plástico reciclado, convertido em Bio-óleo por pirólise avançada.',
      card1_title: 'Certificação ISCC',
      card1_desc: 'Cada crédito tem certificação internacional que garante a rastreabilidade completa do processo.',
      card2_title: 'Apoiado pela Shell',
      card2_desc: 'O Bio-óleo resultante é adquirido pela Shell, assegurando a procura e liquidez do ativo.',
      card3_title: 'Impacto Mensurável',
      card3_desc: 'Cada crédito remove 1 tonelada de plástico do ambiente com verificação independente.',
      card4_title: 'Ativo de Alto Potencial',
      card4_desc: 'Semelhante aos créditos de carbono, o mercado de créditos de plástico está em fase inicial com alto potencial de valorização.',
    },
    process: {
      caption: 'O Processo Corsair',
      title: 'De resíduo a ativo: Tecnologia Waste-to-Oil',
      step1_title: 'Recolha',
      step1_desc: 'Os resíduos plásticos são recolhidos e classificados em instalações certificadas.',
      step2_title: 'Pirólise',
      step2_desc: 'O plástico é transformado em Bio-óleo por pirólise avançada nas instalações do Corsair Group.',
      step3_title: 'Certificação',
      step3_desc: 'Cada lote recebe certificação ISCC, garantindo rastreabilidade e qualidade do Bio-óleo.',
      step4_title: 'Comercialização',
      step4_desc: 'A Shell adquire o Bio-óleo certificado, fechando o ciclo da economia circular.',
      partner: 'Tecnologia apoiada por',
      official_rep: 'Representante Oficial em Espanha',
      partner_desc: 'CSR & Finance Consulting é representante autorizado do Corsair Group em Espanha. Tecnologia Waste-to-Oil apoiada pela Shell com certificação ISCC.',
    },
    value: {
      caption: 'Oportunidade de Investimento',
      title: 'Entrada antecipada no mercado',
      entry_label: 'Preço de entrada atual',
      entry_value: '0,015€',
      entry_unit: 'por crédito',
      market_label: 'Valor de mercado estimado',
      market_value: '0,07€',
      market_unit: 'por crédito',
      potential: 'Potencial de valorização',
      potential_value: '×4.6',
      disclaimer: 'Os valores apresentados representam potencial de valorização baseado em projeções de mercado. Não constituem garantia de rentabilidade.',
      portfolio_title: 'Estratégia de carteira recomendada',
      portfolio_desc: 'Os Créditos de Plástico devem representar 10% a 20% de uma carteira diversificada, combinados com ativos tradicionais para um perfil equilibrado.',
    },
    benefits: {
      caption: 'Benefícios',
      title: 'Soluções para cada perfil',
      ceo_title: 'Para CEOs e Fundadores',
      ceo_benefit1: 'Melhore as métricas ESG da sua empresa com impacto real e verificável',
      ceo_benefit2: 'Evite o greenwashing: cada crédito é certificado e rastreável',
      ceo_benefit3: '78% dos consumidores procuram marcas sustentáveis',
      ceo_benefit4: 'Posicione a sua marca como líder em economia circular',
      ceo_benefit5: 'Cumpra antecipadamente as regulamentações europeias de sustentabilidade',
      investor_title: 'Para Investidores',
      investor_benefit1: 'Aceda a um mercado emergente com alto potencial de valorização',
      investor_benefit2: 'Diversifique a sua carteira com um ativo apoiado por procura real',
      investor_benefit3: 'Preço de entrada preferencial antes da expansão do mercado',
      investor_benefit4: 'Liquidez garantida: a Shell compra 100% do Bio-óleo produzido',
      investor_benefit5: 'Impacto ambiental positivo: investimento com propósito verificável',
    },
    team: {
      caption: 'A Nossa Equipa',
      title: 'Liderada por especialistas em finanças e impacto',
      daniel_name: 'Daniel Domínguez',
      daniel_role: 'Fundador & CEO',
      daniel_bio: 'Consultor financeiro com mais de 15 anos de experiência em planeamento patrimonial e ativos emergentes. Pioneiro na integração de créditos de plástico como instrumento de investimento sustentável no mercado espanhol. Representante autorizado do Corsair Group em Espanha.',
      daniel_specialties: 'Planeamento Patrimonial, Ativos ESG, Créditos de Plástico, Economia Circular',
      linkedin: 'Conectar no LinkedIn',
      cta: 'Agende uma sessão com a nossa equipa',
    },
    booking: {
      caption: 'Sessão Estratégica',
      title: 'Agende a sua consulta personalizada',
      description: 'Em 30 minutos, um dos nossos consultores analisará o seu perfil e mostrará como os Créditos de Plástico podem transformar a sua estratégia patrimonial ou empresarial.',
      cta: 'Reservar Sessão',
      feature1: 'Sem compromisso',
      feature2: 'Análise personalizada',
      feature3: '30 min com um consultor',
    },
    footer: {
      brand: 'CSR & Finance Consulting',
      tagline: 'A sustentabilidade como ativo financeiro.',
      services: 'Serviços',
      service1: 'Planeamento Patrimonial',
      service2: 'Ativos Emergentes',
      service3: 'Créditos de Plástico',
      service4: 'Consultoria ESG',
      legal: 'Legal',
      privacy: 'Política de Privacidade',
      terms: 'Termos e Condições',
      cookies: 'Política de Cookies',
      contact: 'Contacto',
      email: 'info@csrspain.com',
      location: 'Madrid, Espanha',
      rights: '© 2025 CSR & Finance Consulting. Todos os direitos reservados.',
      disclaimer: 'Este site é informativo. Não constitui aconselhamento financeiro. Consulte um profissional antes de tomar decisões de investimento.',
    },
    contact: {
      title: 'Contacte-nos',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefone',
      message: 'Mensagem',
      send: 'Enviar Mensagem',
      success: 'Mensagem enviada com sucesso. Entraremos em contacto brevemente.',
      error: 'Erro ao enviar a mensagem. Tente novamente.',
    },
  },
};
